import React, { Dispatch, SetStateAction, useState } from "react"
import tw from "twin.macro"
import { Login } from "./login"
import { Join } from "./join"

export enum AuthenticatonPage {
  Login = "Login",
  Join = "Join",
}
interface AuthenticationProps {
  view: AuthenticatonPage
  setShow?: Dispatch<SetStateAction<boolean>>
  setNotDismissable?: Dispatch<SetStateAction<boolean>>
  redirectUserAfterCreation?: boolean
}
export const Authentication = ({
  view,
  setShow,
  setNotDismissable,
  redirectUserAfterCreation,
}: AuthenticationProps) => {
  const [page, setPage] = useState(view)

  const renderView = () => {
    switch (page) {
      case AuthenticatonPage.Join: {
        return <Join {...{ setPage, setShow, setNotDismissable, redirectUserAfterCreation }} />
      }
      case AuthenticatonPage.Login: {
        return <Login {...{ setPage, setShow, setNotDismissable }} />
      }
      default: {
        return <Join {...{ setPage, setShow, setNotDismissable, redirectUserAfterCreation }} />
      }
    }
  }
  return <div css={[tw`flex flex-col w-[260px] m-auto my-5`]}>{renderView()}</div>
}
